import { SxProps, Box, MenuItem, MenuList, Popover } from "@mui/material";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import { Option } from "../../../../../../../../constants/common";
import StyledButtonV2 from "../../../../../../../../components/app/StyledButtonV2";
import Flex from "../../../../../../../../components/Flex";
import SearchInput from "../../../../../../../../components/SearchInput";
import { useState } from "react";

interface StyledPopoverButtonProps {
  onClick: (e: any) => void;
  label: string;
  w?: string;
  disableStartIcon?: boolean;
  options: Option[];
  instantSearchStringKey?: string;
  setSearchStringKey: (v: string) => void;
}

const StyledPopoverButton = ({
  onClick,
  label,
  w,
  disableStartIcon,
  options,
  instantSearchStringKey,
  setSearchStringKey,
  ...others
}: StyledPopoverButtonProps & SxProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);
  return (
    <>
      <Box>
        <StyledButtonV2
          sx={{
            minWidth: w ?? "100%",
            display: "flex",
            justifyContent: "start",
            ...others,
          }}
          variant="outlined"
          style={{ color: "#1A1A1A99", backgroundColor: "#1A1A1A0D" }}
          sIcon={!disableStartIcon && <AddCircleOutlineRoundedIcon />}
          size="small"
          label={label}
          onClick={(e) => setAnchorEl(e.currentTarget)}
        />
      </Box>
      <Popover
        id="create-navbar-button-menu"
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box>
          <SearchInput
            searchKey={instantSearchStringKey!}
            onSearch={setSearchStringKey}
            placeholder="Search"
            name="Search Screener"
          />
          <MenuList>
            {options.map((it) => (
              <MenuItem
                key={it.value}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setAnchorEl(null);
                  onClick(it.value);
                }}
              >
                <Flex gap={"10px"}>{it.label}</Flex>
              </MenuItem>
            ))}
          </MenuList>
        </Box>
      </Popover>
    </>
  );
};
export default StyledPopoverButton;
